"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBmTextInput = exports.BmTextInput = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _bmFormEvents = require("../../../bm-form-events");

var _fieldStyles = require("../../../field-styles");

var _stringUtils = require("../../../../../render/items/input-fields/string-utils");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t<input\n\t\t\tname=\"", "\"\n\t\t\ttype=\"text\"\n\t\t\taria-label=\"", "\"\n\t\t\tclass=\"", "\"\n\t\t\tvalue=\"", "\"\n\t\t\tdata-qe-id=\"", "\"\n\t\t\t.value=\"", "\"\n\t\t\t.selectionStart=\"", "\"\n\t\t\t.selectionEnd=\"", "\"\n\t\t\t?required=\"", "\"\n\t\t\t?disabled=\"", "\"\n\t\t\t?readonly=\"", "\"\n\t\t\t@input=\"", "\"\n\t\t\t@blur=\"", "\"\n\t\t/>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmTextInput = /*#__PURE__*/function (_bmFormEventDispatche) {
  (0, _inherits2.default)(BmTextInput, _bmFormEventDispatche);

  var _super = (0, _createSuper2.default)(BmTextInput);

  function BmTextInput() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmTextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.selectionStart = 0;
    _this.selectionEnd = 0;
    return _this;
  }

  (0, _createClass2.default)(BmTextInput, [{
    key: "render",
    value: function render() {
      var selectionEnd;
      var selectionStart;
      var input = this.shadowRoot.querySelector('input');

      if (input && input.selectionStart !== input.selectionEnd) {
        selectionStart = input.selectionStart;
        selectionEnd = input.selectionEnd;
      } else {
        selectionStart = this.selectionStart;
        selectionEnd = this.selectionEnd;
      }

      var label = (0, _stringUtils.sliceBeforeDelimiter)("".concat(this.name));
      var name = (0, _stringUtils.sliceFromDelimiter)("".concat(this.name));
      return this.html(_templateObject(), name, (0, _element.ifDefined)(label || undefined), (0, _element.classMap)(this._getClassMap()), (0, _element.ifDefined)(this.value), (0, _element.ifDefined)(this.dataQeId), this.value, selectionEnd, selectionStart, Boolean(this.required), Boolean(this.disabled), Boolean(this.readonly), this.handleInput, this.handleBlur);
    }
  }, {
    key: "handleInput",
    value: function handleInput(evt) {
      var input = evt.target;
      var currentValue = input.value;
      this.dispatchBmFormEvent({
        type: 'changed',
        data: {
          currentValue: currentValue,
          previousValue: this.value
        }
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(_) {
      if (!this.readonly && !this.touched) {
        this.dispatchBmFormEvent({
          type: 'touched'
        });
      }
    }
  }, {
    key: "_getClassMap",
    value: function _getClassMap() {
      var _classMap = {
        touched: Boolean(this.touched),
        untouched: !this.touched,
        dirty: Boolean(this.dirty),
        pristine: !this.dirty,
        'bm-input': true,
        'bm-fe-input': true
      };
      return _classMap;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-text-input';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        name: {
          type: String,
          attribute: false,
          reflect: false
        },
        disabled: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        readonly: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        required: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        touched: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        dirty: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        value: {
          type: String,
          attribute: false,
          reflect: false
        },
        dataQeId: {
          type: String,
          attribute: false,
          reflect: false
        },
        selectionStart: {
          type: Number,
          attribute: false,
          reflect: false
        },
        selectionEnd: {
          type: Number,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [_fieldStyles.bmLabelStyles, _fieldStyles.bmFormFieldStyles];
    }
  }]);
  return BmTextInput;
}((0, _bmFormEvents.bmFormEventDispatcher)(_element.BlueElement));

exports.BmTextInput = BmTextInput;

var registerBmTextInput = function registerBmTextInput() {
  (0, _element.register)(BmTextInput);
};

exports.registerBmTextInput = registerBmTextInput;
